module.exports = __webpack_public_path__ + "img/tirando-foto.b15f34cd.svg";